/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCopyControlLookup.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/copy-control-lookup";

export class AutogenModelCopyControlLookup<RowType extends ModelRow> extends Endpoint<RowType, RowCopyControlLookupFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCopyControlLookup extends ModelRow<RowCopyControlLookupFields> {
	constructor(values?: Partial<RowCopyControlLookupFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCopyControlLookupFields {
	ace_id: string;
	address1: string;
	address2: string;
	allocation: string;
	bill_distance: string;
	bill_of_lading: string;
	bol_received: string;
	booking_no: string;
	brk_qual_profile: string;
	brokerage_workflow: string;
	carrier_cost: string;
	city: string;
	comments: string;
	company_id: string;
	company_type: string;
	consignee_ref: string;
	container_dates: string;
	container_dray_pay: string;
	container_ldport: string;
	container_number: string;
	container_order: string;
	container_pod: string;
	container_type: string;
	container_vessel: string;
	copy_allocation_id: string;
	copy_bill_to: string;
	copy_car_to_frght: string;
	copy_ctrl_party: string;
	copy_ovrd_payee: string;
	copy_revenue_id: string;
	copy_status: string;
	copy_to_company: string;
	copy_type: string;
	currency: string;
	cust_order_no: string;
	dates: string;
	def_move_type: string;
	delivered_orders: string;
	descr: string;
	distance_um: string;
	dot_number: string;
	dray_transfer_date: string;
	driver_load_unload: string;
	edi_status: string;
	eir1_no: string;
	eir2_no: string;
	email_address: string;
	email_bcc: string;
	email_client: string;
	email_host: string;
	email_imap_host: string;
	email_imap_password: string;
	email_imap_sent_folder: string;
	email_imap_ssl: string;
	email_imap_username: string;
	email_password: string;
	email_port: number;
	email_protocol: string;
	email_use_sent_folder: string;
	email_username: string;
	enable_br_ltl: string;
	enable_dd_encryption: string;
	enable_encryption: string;
	enable_mfa: string;
	enable_phoneformat: string;
	enable_portal_mfa: string;
	enable_transferlog: string;
	enable_web_mfa: string;
	equip_match_detail: string;
	excise_taxes: string;
	fax: string;
	forwarder: string;
	free_days: string;
	freight_items: string;
	handling_req: string;
	ic_alloc_code: string;
	ic_order_type: string;
	ic_resp_code: string;
	ic_rev_code: string;
	icon_image: string;
	id: string;
	import_export: string;
	include_brokerage_status: string;
	is_main_company: string;
	lock_miles: string;
	logo: string;
	logo_name: string;
	ltl_company: string;
	mfa_prompt_interval: number;
	multi_curr_enabled: string;
	name: string;
	order_length: string;
	order_type: string;
	order_value: string;
	orig_allocation_id: string;
	orig_ctrl_party: string;
	orig_ovrd_payee: string;
	orig_revenue_id: string;
	orig_zero_excise_taxes: string;
	orig_zero_frt_chg: string;
	orig_zero_othr_chg: string;
	orig_zero_ovr_pay: string;
	original_bill_to: string;
	original_status: string;
	other_charges: string;
	phone_format: string;
	phone_number: string;
	pick_up_no: string;
	rate: string;
	ready_to_bill: string;
	reference_numbers: string;
	revenue: string;
	scac: string;
	security_admin_email: string;
	showas_location: string;
	state: string;
	stops: string;
	support_email: string;
	temperature_um: string;
	user_lic_contact_email: string;
	user_lic_contact_name: string;
	user_lic_contact_phone: string;
	website: string;
	weight: string;
	weight_um: string;
	y_splits: string;
	zip: string;
}

